import PropTypes from 'prop-types';
import { Button, Card, LoaderSkeleton } from '@utilities';

import Prompts from './components/Prompts';
import Results from './components/Results';

import styles from './_index.module.scss';

const BodyCard = ({
  activePrompt,
  getPillTooltip,
  getPillValue,
  handleBuild,
  handleClose,
  isBuildDisabled,
  isBuilding,
  isLoading,
  narrativeId,
  onAnswerChange,
  prompts,
  sameLevelPrompts,
  searchPrompts,
  selectedAnswers,
  setActivePrompt,
  setSelectedAnswers,
  transformedAnswersMap,
  type,
}) => {
  if (isLoading || !prompts?.length || !activePrompt) {
    return (
      <Card className={`${styles['body-card']} ${styles['placeholder-body-card']}`}>
        <LoaderSkeleton height={400} width={1020}>
          <rect height="40" rx="12" ry="12" width="260" x="0" y="0" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="60" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="120" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="180" />
          <rect height="40" rx="12" ry="12" width="260" x="0" y="240" />
          <rect height="15" rx="4" ry="4" width="160" x="280" y="0" />
          <rect height="15" rx="4" ry="4" width="140" x="280" y="30" />
          <rect height="15" rx="4" ry="4" width="150" x="280" y="60" />
          <rect height="15" rx="4" ry="4" width="130" x="280" y="90" />
          <rect height="15" rx="4" ry="4" width="160" x="280" y="120" />
          <rect height="15" rx="4" ry="4" width="125" x="280" y="150" />
          <rect height="15" rx="4" ry="4" width="145" x="280" y="180" />
          <rect height="15" rx="4" ry="4" width="150" x="280" y="210" />
          <rect height="15" rx="4" ry="4" width="130" x="480" y="0" />
          <rect height="15" rx="4" ry="4" width="140" x="480" y="30" />
          <rect height="15" rx="4" ry="4" width="110" x="480" y="60" />
          <rect height="15" rx="4" ry="4" width="120" x="480" y="90" />
          <rect height="15" rx="4" ry="4" width="130" x="480" y="120" />
          <rect height="15" rx="4" ry="4" width="100" x="480" y="150" />
          <rect height="15" rx="4" ry="4" width="140" x="480" y="180" />
        </LoaderSkeleton>
      </Card>
    );
  }

  return (
    <Card className={styles['body-card']}>
      <div className={styles['body-card-content']}>
        <Prompts
          activePrompt={activePrompt}
          getPillTooltip={getPillTooltip}
          getPillValue={getPillValue}
          prompts={prompts}
          setActivePrompt={setActivePrompt}
          setSelectedAnswers={setSelectedAnswers}
          transformedAnswersMap={transformedAnswersMap}
          type={type}
        />
        <div>
          <Results
            activePrompt={activePrompt}
            narrativeId={narrativeId}
            onAnswerChange={onAnswerChange}
            sameLevelPrompts={sameLevelPrompts}
            searchPrompts={searchPrompts}
            selectedAnswers={selectedAnswers}
            setSelectedAnswers={setSelectedAnswers}
            transformedAnswersMap={transformedAnswersMap}
          />
          <div className={styles['body-card-actions']}>
            <Button onClick={handleClose} text="Cancel" variant="secondary" />
            <Button
              isDisabled={isBuildDisabled}
              isLoading={isBuilding}
              onClick={handleBuild}
              text="Build"
              variant="primary"
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

BodyCard.propTypes = {
  activePrompt: PropTypes.object,
  getPillTooltip: PropTypes.func,
  getPillValue: PropTypes.func,
  handleBuild: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  isBuildDisabled: PropTypes.bool.isRequired,
  isBuilding: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  narrativeId: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  prompts: PropTypes.array.isRequired,
  sameLevelPrompts: PropTypes.array,
  searchPrompts: PropTypes.array,
  selectedAnswers: PropTypes.object,
  setActivePrompt: PropTypes.func,
  setSelectedAnswers: PropTypes.func,
  transformedAnswersMap: PropTypes.object,
  type: PropTypes.string,
};

export default BodyCard;
